export const AUTO_INVENTORY_REPLENISHMENT_EN = {
  autoInventoryRepl: 'Auto Inventory Replenishment',
  numberSellDays: 'Number sell days for auto replenish inventory',
  coverDay: 'Number Sell Days',
}
